// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__Ssyh0","section":"styles_section__rD13b","heading":"styles_heading__nWwsS","back":"styles_back__g-FIc"};